import { useEffect } from "react";

import { XAPI_OBJECT_TYPES } from "@models/tracking/event-types";
import { SearchEvent } from "@models/tracking/xapi-events";
import { SearchBox, useSearch } from "@transfr-inc/dashboard-components/forms";

export function DevicesSearchbox({
  data,
  setFilteredDevices,
  tracking,
  organizationCode,
}) {
  const deviceNameSearch = useSearch({
    data,
    searchKeys: ["name"],
  });

  useEffect(() => {
    if (data && data.length > 0) {
      deviceNameSearch.updateData(data);
    }
  }, [data]);

  const onDeviceTermChange = (term) => {
    const results = deviceNameSearch.queryData(term);
    tracking.trackEvent(
      new SearchEvent(
        `headset_search_${organizationCode}`,
        `headset_search_${organizationCode}`,
        XAPI_OBJECT_TYPES.SEARCH_BAR
      )
    );
    setFilteredDevices(term ? results : undefined);
  };

  const onDeviceSearchSelected = (device) => {
    setFilteredDevices([device]);
  };

  return (
    <SearchBox
      placeholder={"Search"}
      data={data}
      query={deviceNameSearch.queryData}
      onSearchTermChange={onDeviceTermChange}
      onResultSelected={onDeviceSearchSelected}
      optionComponent={(r) => <div>{r?.name}</div>}
      customOptionLabel={(device) => device.name}
    />
  );
}
